export default __webpack_public_path__ + "static/media/Apa.92552021.svg";